document.querySelectorAll('.adaptive_config').forEach(function(div) {
    var dataset = div.dataset;
    var adaptiveConfig = dataset.adaptiveConfig;
    if (!adaptiveConfig) return;
    adaptiveConfig = JSON.parse(adaptiveConfig);
    var innerWidth = window.innerWidth;
    adaptiveConfig.forEach(function(el) {
        if (el.minWidth && el.minWidth > innerWidth) return;
        var datasets = Object.entries(el.data);
        datasets.forEach(function (entry) {
            var key = entry[0];
            var value = entry[1];
            if (!dataset[key]) dataset[key] = value;
        });
        if (el.classes) el.classes.forEach(function (entry) {
            var enable = true;
            var className = entry;
            if (Array.isArray(entry)) {
                className = entry[0];
                enable = entry[1];
            }
            if (enable) div.classList.add(className);
            else div.classList.remove(className)
        });
    });
});